import { secureHttp } from "../utils/request";

export const getMemberReviewSchemes = async (memberID: string) => {
    try {
        const {data} = await secureHttp.get(`/review/schemes/memberreviewschemes/${memberID}`);

        return data.data || [];

    } catch (e) {
        console.error(e);
    }
}

export const createReview = async (payload: any) => {
    await secureHttp.post('/review', payload);
}
